import type { CalendlyClientInterface } from './calendlyClient.types';
import CorporateCalendlyClient from './corporateCalendlyClient';
import type { ClientContext } from '~/services/contextClient';

export default class CalendlyClientFactory {
    static createClient(context: Omit<ClientContext, 'groupId'>): CalendlyClientInterface {
        return new CorporateCalendlyClient(context.teamId);
    }
}
